import { useTranslation } from 'react-i18next';
import { Grid } from '@/common/components/Grid/Grid';
import { PageLayout } from '@/common/components/PageLayout/PageLayout';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import {
  getSectionsByPlan,
  useShouldShowTaxProfile,
} from './ProfilePersonalDetailsPage.utils';
import { AddressCard } from './components/AddressCard/AddressCard';
import { BankInfoCard } from './components/BankInfoCard/BankInfoCard';
import { ContactsCard } from './components/ContactsCard/ContactsCard';
import { DocumentsSection } from './components/DocumentsSection/DocumentsSection';
import { TaxProfileCard } from './components/TaxProfileCard/TaxProfileCard';
import { YourDetailsCard } from './components/YourDetailsCard/YourDetailsCard';

export function ProfilePersonalDetailsPage() {
  const { t } = useTranslation();
  const { employee, company } = useEmployeeDetails();

  const sections = getSectionsByPlan(company.settings?.plan);
  const shouldShowTaxProfile = useShouldShowTaxProfile(sections.taxProfile);

  return (
    <PageLayout
      headerProps={{
        title: t('dashboard.personal_info.title'),
        backButton: true,
      }}
    >
      {sections.personal && (
        <Grid gap="page" columnBasis="basis-1/2">
          <YourDetailsCard employee={employee} plan={company.settings?.plan} />
        </Grid>
      )}
      <Grid gap="page" columnBasis="basis-[30rem]">
        {sections.contact && <ContactsCard employee={employee} />}
        {sections.address && <AddressCard employee={employee} />}
        {sections.bank && <BankInfoCard employee={employee} />}
        {shouldShowTaxProfile && <TaxProfileCard />}
      </Grid>
      {sections.documents && <DocumentsSection />}
    </PageLayout>
  );
}
